import { Plus, Trash2 } from "lucide-react"
import { motion } from "framer-motion"
import type { CategoriesResponse, CatalogMaterial, SelectedMaterial } from "../../../../types/calculadoraDeMateriales.ts"
import { ulVariants } from "../../../../constants/calculadoraDeMateriales.ts"
import styles from "../CalculadoraDeMateriales.module.scss"

type CalculadoraExpandedMaterialsListProps = {
  categories: CategoriesResponse
  selectedCategory: string
  selectedMaterials: SelectedMaterial[]
  isEstimacionDeCostos: boolean
  toggleMaterial: (material: CatalogMaterial, categoryId: string) => void
  onCreateCustomMaterialFromList: () => void
  onOpenMaterialDetail: (materialId: number | string) => void
}

const CalculadoraExpandedMaterialsList = ({
  categories,
  selectedCategory,
  selectedMaterials,
  isEstimacionDeCostos,
  toggleMaterial,
  onCreateCustomMaterialFromList,
  onOpenMaterialDetail,
}: CalculadoraExpandedMaterialsListProps) => {
  const selectedCategoryRow = categories?.data?.find((cat) => String(cat.id) === selectedCategory)
  const selectedCategoryName = selectedCategoryRow?.name ?? selectedCategory
  const selectedCategoryMaterials = selectedCategoryRow?.materials ?? []

  return (
    <motion.ul
      variants={ulVariants}
      initial="hidden"
      animate="visible"
      className={styles.container_body_categoryMaterials_list}
    >
      <li
        className={`${styles.container_body_categoryMaterials_list_item} ${styles.customMaterialListItem}`}
        onClick={onCreateCustomMaterialFromList}
        style={{ cursor: "pointer" }}
      >
        <div className={styles.container_body_categoryMaterials_list_item_text}>
          <span className={styles.container_body_categoryMaterials_list_item_material}>Crear material personalizado</span>
          <span className={styles.container_body_categoryMaterials_list_item_category}>
            Agrega un material que no esté en la lista
          </span>
        </div>
        <div className={styles.container_body_categoryMaterials_list_item_buttonContainer}>
          <button
            className={`${styles.container_body_categoryMaterials_list_item_button} ${styles.customMaterialButton}`}
          >
            Crear
          </button>
        </div>
      </li>
      {selectedCategoryMaterials.map((material) => {
          const isChecked = selectedMaterials.some((m) => m.id === material.id)
          const category = selectedCategoryName
          return (
            <li
              key={material.id}
              className={styles.container_body_categoryMaterials_list_item}
              onClick={() => toggleMaterial(material, selectedCategory)}
              style={{ cursor: "pointer" }}
            >
              <div className={styles.container_body_categoryMaterials_list_item_text}>
                <span className={styles.container_body_categoryMaterials_list_item_material}>{material.name}</span>
                <span className={styles.container_body_categoryMaterials_list_item_category}>{category}</span>
              </div>
              <div
                className={`${styles.container_body_categoryMaterials_list_item_buttonContainer} 
                            ${!isEstimacionDeCostos && styles.container_body_categoryMaterials_list_item_buttonContainer_estimacionDeCostos}`}
              >
                <div className={styles.container_body_categoryMaterials_list_item_quantity}>
                  <div className={styles.container_body_categoryMaterials_list_item_meta}>
                    {isEstimacionDeCostos && material.price != null && (
                      <span>
                        {new Intl.NumberFormat("es-AR", {
                          style: "currency",
                          currency: "ARS",
                        }).format(material.price)}
                      </span>
                    )}
                    <span>{material.unit}</span>
                  </div>
                  <button
                    type="button"
                    onClick={(e) => {
                      e.stopPropagation()
                      onOpenMaterialDetail(material.id)
                    }}
                    className={styles.container_body_categoryMaterials_list_item_linkBtn}
                  >
                    Ver detalle
                  </button>
                </div>
                <button
                  onClick={(e) => {
                    e.stopPropagation()
                    toggleMaterial(material, selectedCategory)
                  }}
                  className={`${styles.container_body_categoryMaterials_list_item_button} 
                                ${isChecked && styles.container_body_categoryMaterials_list_item_button_checked}`}
                >
                  {isChecked ? <Trash2 size={16} /> : <Plus size={16} />}
                </button>
              </div>
            </li>
          )
        })}
    </motion.ul>
  )
}

export default CalculadoraExpandedMaterialsList
